import React from "react";

export const UpsellLoader = () => {
    return <div className="loader">
        <i className="fa fa-refresh fa-spin loader-icon"></i>
    </div>;
};


